import { Component, HostListener, Inject, inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { ToastComponent } from './components/asahi/toast/toast.component';
import { Title ,Meta} from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-root',
  standalone:true,
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  constructor(private titleService: Title,  private metaService: Meta, private router: Router,@Inject(PLATFORM_ID) private platformId: any) {}
  title = 'Leads';
  @HostListener('window:keydown', ['$event'])
  handleKeyboardZoom(event: KeyboardEvent): void {
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === '+' || event.key === '-' || event.key === '=' || event.key === '0')
    ) {
      event.preventDefault();
    }
  }



  get isPlatformBrowser() {
    return isPlatformBrowser(this.platformId)
  }

  @HostListener('window:wheel', ['$event'])
  handleMouseWheelZoom(event: WheelEvent): void {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  }

  @HostListener('document:gesturestart', ['$event'])
  @HostListener('document:gesturechange', ['$event'])
  @HostListener('document:gestureend', ['$event'])
  handleGestureEvents(event: Event): void {
    event.preventDefault();
  }

  async ngOnInit() {
  this.router.events
    .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
    .subscribe((event) => {
      const url = event.urlAfterRedirects.split('?')[0]; // remove query params
      console.log('Current route:', url);

      if (url.endsWith('/car-insurance') || url.includes('/car-insurance')) {
        this.updateMeta(
          'Car Insurance',
          'Secure your car against every unexpected risk on the road.',
          window.location.href
        );
      } 
      else if (url.endsWith('/income-protection-insurance') || url.includes('/income-protection-insurance')) {
        this.updateMeta(
          'Income Protection Insurance',
          'Protect your income and secure your family’s financial stability even in uncertain times.',
          window.location.href
        );
      } 
      else {
        this.updateMeta(
          'LivWell',
          'Live well with LivWell — your trusted protection partner.',
          window.location.href
        );
      }
    });
}

  updateMeta(title: string, desc: string, url: string) {
  this.titleService.setTitle(title);

  this.metaService.updateTag({ name: 'description', content: desc });
  this.metaService.updateTag({ property: 'og:title', content: title });
  this.metaService.updateTag({ property: 'og:description', content: desc });
  this.metaService.updateTag({ property: 'og:url', content: url });
  this.metaService.updateTag({ property: 'og:type', content: 'website' });
  this.metaService.updateTag({
    property: 'og:image',
    content: 'https://lead.livwell.vn/assets/images/livwell-banner.png'
  });
}

}

